// src/utils/StorageService.js

const StorageService = {
    // Get value by key
    get: function (key) {
      const value = localStorage.getItem(key);
      try {
        return value ? JSON.parse(value) : null;
      } catch (e) {
        return value;
      }
    },
  
    // Set value by key
    set: function (key, value) {
      const stringified = typeof value === 'string' ? value : JSON.stringify(value);
      localStorage.setItem(key, stringified);
    },
  
    // Remove value by key
    remove: function (key) {
      localStorage.removeItem(key);
    },
  
    // Clear all local storage
    clear: function () {
      localStorage.clear();
    },
  
    // Update (merge) existing object value
    update: function (key, newData) {
      const existing = this.get(key);
      const updated = { ...(existing || {}), ...newData };
      this.set(key, updated);
    }
  };
  
  export default StorageService;
  